import { render, staticRenderFns } from "./Impressoras.vue?vue&type=template&id=3cfb89b2&scoped=true"
import script from "./Impressoras.vue?vue&type=script&lang=js"
export * from "./Impressoras.vue?vue&type=script&lang=js"
import style0 from "./Impressoras.vue?vue&type=style&index=0&id=3cfb89b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfb89b2",
  null
  
)

export default component.exports